import styled from 'styled-components';
export var CountryFlagSVG = styled.svg.withConfig({
  componentId: "sc-dl6nan-0"
})(["width:28px;height:22px;"]);
export var CountryFlagImage = styled.image.withConfig({
  componentId: "sc-dl6nan-1"
})(["width:28px;height:22px;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/internal/Dropdown/styled.js
// module id = 4513
// module chunks = 11